import React, {useState} from 'react';
import {observer} from 'mobx-react-lite';
import ResourceGridView from "../../../components/grid/ResourceGridView";
import {TeamOutput} from "../../../generated";
import {useStore} from "../../../context";
import {TeamStore} from "./team-store";
import {TeamEditModal} from "./team-edit-modal";

export const TeamList = observer(() => {
    const {uiBus} = useStore()
    const [store] = useState(() => new TeamStore(uiBus));

    return <div className={'dashboard'}>
        <ResourceGridView<TeamOutput>
            gridResource={store}
            columns={[
                'id',
                {
                    name: 'Name',
                    value: (entity) => entity.name,
                },
                {
                    name: 'Manager',
                    value: (entity) => entity.manager.username,
                },
                {
                    name: 'Members',
                    value: (entity) => <ul>
                        {entity.members.map(member => <li key={member.id}>{member.username}</li>)}
                    </ul>,
                }
            ]}
            onCreate={() => {
                store.openNewTeamModal();
            }}
            onRowClick={(team) => {
                store.selectTeam(team);
            }}
        />
        {store.isModalOpen && <TeamEditModal store={store}/>}
    </div>
})
